namespace RioERP.Web.Enums {
    export enum EWatchTime {
        Zero = 0,
        One = 1,
        OnePointOne = 2,
        OnePointTwo = 3,
        OnePointThree = 4,
        OnePointFour = 5,
        OnePointFive = 6,
        OnePointSix = 7,
        OnePointSeven = 8,
        OnePointEight = 9,
        OnePointNine = 10,
        Two = 11,
        TwoPointOne = 12,
        TwoPointTwo = 13,
        TwoPointThree = 14,
        TwoPointFour = 15,
        TwoPointFive = 16,
        TwoPointSix = 17,
        TwoPointSeven = 18,
        TwoPointEight = 19,
        TwoPointNine = 20,
        Three = 21,
        ThreePointOne = 22,
        ThreePointTwo = 23,
        ThreePointThree = 24,
        ThreePointFour = 25,
        ThreePointFive = 26,
        ThreePointSix = 27,
        ThreePointSeven = 28,
        ThreePointEight = 29,
        ThreePointNine = 30,
        Four = 31,
        FourPointFive = 32,
        Five = 33,
        FivePointFive = 34,
        Six = 35,
        SixPointFive = 36,
        Seven = 37,
        SevenPointFive = 38,
        Eight = 39,
        EightPointFive = 40,
        Nine = 41,
        NinePointFive = 42,
        Ten = 43,
        Eleven = 44,
        Twelve = 45,
        Thirteen = 46,
        Fourteen = 47,
        Fifteen = 48,
        Sixteen = 49,
        Seventeen = 50,
        Eighteen = 51,
        Nineteen = 52,
        Twenty = 53,
        TwentyOne = 54,
        TwentyTwo = 55,
        TwentyThree = 56,
        TwentyFour = 57,
        TwentyFive = 58,
        Thirty = 59,
        ThirtyFive = 60,
        Forty = 61,
        Fifty = 62,
        Sixty = 63,
        Seventy = 64,
        Eighty = 65,
        Ninty = 66,
        Hundred = 67,
        TwoHundred = 68,
        ThreeHundred = 69,
        FiveHundred = 70,
        Thousand = 71,
        Unlimited = 72
    }
    Serenity.Decorators.registerEnumType(EWatchTime, 'RioERP.Web.Enums.EWatchTime');
}
